import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { IOpeningEstimationData } from "common/records/OpeningEstimation";

export const RECEIVE_OPENING_ESTIMATION = "@openingEstimation/RECEIVE_OPENING_ESTIMATION";
export const DUPLICATE_OPENING_ESTIMATION = "@openingEstimation/DUPLICATE_OPENING_ESTIMATION";
export const DECREMENT_OPENING_ESTIMATION_UNSAVED_ID = "@openingEstimation/DECREMENT_OPENING_ESTIMATION_UNSAVED_ID";

export const OpeningEstimationActions = {
  receiveOpeningEstimation: (openingEstimation: Partial<IOpeningEstimationData>) =>
    createAction(RECEIVE_OPENING_ESTIMATION, { openingEstimation }),
  /**
   * Duplicates an opening estimation onto a new line item (mirrors duplicateEstimateLineItemOption).
   *
   * @param sourceOpeningEstimationId The id of the opening estimation to duplicate
   * @param targetLineItemId The id of the line item to add the duplicated opening estimation to
   */
  duplicateOpeningEstimation: (sourceOpeningEstimationId: number, targetLineItemId: number) =>
    createAction(DUPLICATE_OPENING_ESTIMATION, { sourceOpeningEstimationId, targetLineItemId }),
  decrementUnsavedId: () => createAction(DECREMENT_OPENING_ESTIMATION_UNSAVED_ID),
};

export type OpeningEstimationActions = ActionsUnion<typeof OpeningEstimationActions>;
